import Vue from 'vue'
import Vuex from 'vuex'
import { app } from '@/store/app.js'
import { onboarding } from '@/store/onboarding.js'
import { userprofile } from '@/store/userprofile.js'
import { reservations } from '@/store/reservations.js'
import { upsell } from '@/store/upsell.js'
import { wayfinding } from '@/store/wayfinding.js'
import { events } from '@/store/events.js'
import { settings } from '@/store/settings.js'
import { checkin } from '@/store/checkin.js'
import { content } from '@/store/content.js'
import { modal } from '@/store/modal.js'
import { CollectionModule } from '@/store/CollectionModule'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    newAppVersionAvailable: false
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    app: app(),
    onboarding: onboarding(),
    userprofile: userprofile(),
    upsell: upsell(),
    wayfinding: wayfinding(),
    events: events(),
    settings: settings(),
    checkin: checkin(),
    content: content(),
    reservations: reservations(),
    modal: modal()
  }
})


export default store

export const collectionModuleName = (collection) => {
  const moduleName = 'content_' + collection
  if (!store.hasModule(moduleName)) {
    store.registerModule(moduleName, CollectionModule())
  }

  return moduleName
}
